import { render, staticRenderFns } from "./FindingCard.vue?vue&type=template&id=34dec1e0&scoped=true&"
import script from "./FindingCard.vue?vue&type=script&lang=js&"
export * from "./FindingCard.vue?vue&type=script&lang=js&"
import style0 from "./FindingCard.vue?vue&type=style&index=0&id=34dec1e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34dec1e0",
  null
  
)

export default component.exports